import React, { useState, useEffect } from 'react';
import { Button, Popover, Modal } from 'antd';
import { connect } from 'react-redux';
import './Placeholder.css';
import ComponentSelectionForm from './ComponentSelectionForm';
import ComponentWrapper from '../../components/ComponentWrapper';
import { ImportModule } from '../../components/DynamicImporter';
import uuidv4 from 'uuid/v4';
import { addComponentToPage, updateComponentOfPage, clearComponentsOfField, removeSingleComponentOfField, swapComponentsOfField } from '../../../actions/singlePage.actions';

const { confirm } = Modal;

const Placeholder = props => {
    const { page } = props;
    const [components, setComponents] = useState(props.children || []);
    const [addComponentVisible, setAddComponentVisible] = useState(false);
    const [dynamicClass] = useState('');

    useEffect(() => {
        if (components.length === 0 && page !== undefined && page.templateConf !== undefined) {
            let fieldComponents = page.templateConf[props.fieldName];
            if (fieldComponents) {
                fieldComponents.forEach(comp => {
                    createComponent(comp.type, comp.props);
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [components, page]);

    const handleComponentSelected = componentName => {
        createComponent(componentName, null);

        props.addComponentToPage({
            fieldName: props.fieldName,
            component: componentName
        });
    };

    const createComponent = (componentName, compProps) => {
        let comps = !Array.isArray(components) ? [components] : components;
        let key = uuidv4();

        if (props.editMode === true) {
            comps.push(
                <ComponentWrapper
                    key={key}
                    id={key}
                    compName={componentName}
                    compProps={compProps}
                    onRemove={handleRemoveComponentClicked}
                    onMoveUpClicked={handleComponentMoveUpClicked}
                    onMoveDownClicked={handleComponentMoveDownClicked}
                    updateProps={updateComponentProps}
                />
            );
        } else {
            comps.push(<ImportModule name={componentName} props={compProps} key={key} />);
        }

        setComponents([...components]);
        setAddComponentVisible(false);
    };

    const handleComponentMoveUpClicked = id => {
        let index = components.findIndex(comp => comp.key === id);
        if (index > 0) {
            props.swapComponentsOfField({
                fieldName: props.fieldName,
                index: index,
                newIndex: index - 1
            });
            setComponents([]);
        }
    };

    const handleComponentMoveDownClicked = id => {
        let index = components.findIndex(comp => comp.key === id);
        if (index < components.length - 1) {
            props.swapComponentsOfField({
                fieldName: props.fieldName,
                index: index,
                newIndex: index + 1
            });
            setComponents([]);
        }
    };

    const handleRemoveComponentClicked = id => {
        confirm({
            title: "Are you sure you'd like to remove this component ?",
            content: "All of it's settings will be lost.",
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            cancelType: 'default',

            onOk: () => {
                let index = components.findIndex(comp => comp.key === id);
                props.removeSingleComponentOfField({
                    fieldName: props.fieldName,
                    index: index
                });
                setComponents([]);
            }
        });
    };

    const handleRemoveAllClicked = () => {
        confirm({
            title: "Are you sure you'd like to remove all components ?",
            content: 'All of thier settings will be lost.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            cancelType: 'default',
            onOk: () => {
                props.clearComponentsOfField(props.fieldName);
                setComponents([]);
            }
        });
    };

    const updateComponentProps = (id, newProps) => {
        let index = components.findIndex(comp => comp.key === id);

        props.updateComponentOfPage({
            fieldName: props.fieldName,
            index: index,
            newProps: newProps
        });
    };

    const createSettingsJSX = () => {
        const { editMode } = props;

        return editMode ? (
            <div className="settings fixed--bottomRight">
                <div className="settings-actions">
                    <Popover
                        placement="left"
                        trigger={['click']}
                        onVisibleChange={visible => setAddComponentVisible(visible)}
                        content={<ComponentSelectionForm compList={props.compList} onComponentSelected={handleComponentSelected} />}
                        visible={addComponentVisible}>
                        <Button
                            type="primary"
                            shape="circle"
                            icon="plus"
                            size="small"
                            onClick={() => {
                                setAddComponentVisible(true);
                            }}
                        />
                    </Popover>
                    <Button type="danger" title="Remove all components" onClick={handleRemoveAllClicked} shape="circle" icon="delete" size="small" />
                </div>
                <div className="settings-trigger">
                    <Button type="warning" shape="circle" icon="setting" size="default" />
                </div>
            </div>
        ) : (
            ''
        );
    };

    const { editMode } = props;

    if (editMode && (!components || (Array.isArray(components) && components.length === 0))) {
        return (
            <div className="compPlaceholder compPlaceholder--editMode compPlaceholder--empty">
                <Popover
                    placement="left"
                    trigger={['click']}
                    onVisibleChange={visible => setAddComponentVisible(visible)}
                    content={<ComponentSelectionForm compList={props.compList} onComponentSelected={handleComponentSelected} />}
                    visible={addComponentVisible}>
                    <Button
                        type="primary"
                        shape="circle"
                        icon="plus"
                        size="default"
                        className="fixed--bottomRight"
                        onClick={() => {
                            setAddComponentVisible(true);
                        }}
                    />
                </Popover>
            </div>
        );
    } else {
        return (
            <div className={'compPlaceholder ' + (editMode ? 'compPlaceholder--editMode ' : '') + dynamicClass}>
                {components}
                {createSettingsJSX()}
            </div>
        );
    }
};

const mapStateToProps = state => ({
    i18n: state.i18n,
    page: state.page.page
});

const mapDispatchToProps = {
    addComponentToPage,
    updateComponentOfPage,
    clearComponentsOfField,
    removeSingleComponentOfField,
    swapComponentsOfField
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Placeholder);
